import { useAuth } from '@/src/hooks/useAuth'
import { toast } from '@/src/lib/toast'
import { useGetUserWishlistDataQuery } from '@/src/store/rtkQueries/userGetAPI'
import { useAddToWishlistMutation, useRemoveFromWishlistMutation } from '@/src/store/rtkQueries/userPostAPI'
import { openDrawer } from '@/src/store/slices/allDrawerSlice'
import { HeartFilledSVG, HeartOutlineSVG } from '@/src/ui/AllSVG'
import { Button, Spinner } from '@heroui/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { IUserWishlistAPIResponseData } from '@/src/types/wishlist'

interface AddToWishlistProps {
    product_id: string
    is_full_btn?: boolean
    isAlreadyWishlist: boolean
}
export default function AddToWishlist({ product_id, is_full_btn, isAlreadyWishlist }: AddToWishlistProps) {
    const dispatch = useDispatch()
    const [addToWishlist, { isLoading: isAdding }] = useAddToWishlistMutation()
    const [removeFromWishlist, { isLoading: isRemoving }] = useRemoveFromWishlistMutation()
    const isBusy = isAdding || isRemoving
    const { isAuthenticated } = useAuth();
    const { data: wishlistData } = useGetUserWishlistDataQuery(undefined, { skip: !isAuthenticated });
    const isInWishlist = wishlistData?.data?.some(
        (item: IUserWishlistAPIResponseData) => item.product_id?._id === product_id
    ) ?? isAlreadyWishlist;

    const handleWishlist = async (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            const response = isInWishlist
                ? await removeFromWishlist({ product_id }).unwrap()
                : await addToWishlist({ product_id }).unwrap()

            if (response.http_status_code === 200 || response.http_status_code === 201) {
                toast.success(response.message || (isInWishlist ? 'Removed from wishlist' : 'Added to wishlist'))
            }
        } catch (error: unknown) {
            console.error('Error updating wishlist', error);
            const err = error as { data?: { httpStatus?: number } }
            const status = err?.data?.httpStatus
            if (status === 401) {
                dispatch(openDrawer({ componentName: 'AuthDrawer', placement: 'right', className: 'rounded-none w-[500px]' }))
            }
        }
    }
    return (
        <>
            {is_full_btn
                ? <Button
                    className="global_btn rounded_full outline_primary w-full h-12 uppercase"
                    onClick={handleWishlist}
                    isDisabled={isBusy}
                    aria-label="Add to wishlist"
                >
                    {isInWishlist ? (
                        <><HeartFilledSVG />  {isBusy ? 'Removing...' : 'Remove from Wishlist'}</>
                    ) : (
                        <>
                            <HeartOutlineSVG />
                            {isBusy ? 'Saving...' : 'Save to Wishlist'}
                        </>
                    )}
                </Button>
                : <button
                    onClick={handleWishlist}
                    disabled={isBusy}
                    className={`inline-flex items-center justify-center ${isBusy ? 'opacity-60 cursor-not-allowed' : ''}`}
                    aria-label="Add to wishlist"
                >
                    {isInWishlist
                        ? isBusy ? <Spinner size="sm" color="current" /> : <HeartFilledSVG />
                        : isBusy ? <Spinner size="sm" color="current" /> : <HeartOutlineSVG />
                    }
                </button>
            }
        </>
    )
}
